import { MDSIcon, MDSLNBItem } from '@marqvision/mds-v2';
import {
  AnalyticsRouteEnum,
  MarketplaceRouteEnum,
  PortfolioRouteEnum,
  PriceMonitoringRouteEnum,
  RootRouteEnum,
  SocialMediaRouteEnum,
} from '~/router/@types';
import { ROOT_ROUTE_LABELS } from '~/constants/@constants';

export const MARQ_AI_LNB: MDSLNBItem[][] = [
  [
    {
      key: RootRouteEnum.Home,
      path: `/${RootRouteEnum.Home}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.Home],
      icon: <MDSIcon.Home variant="outline" />,
    },
    {
      key: RootRouteEnum.Analytics,
      shouldCollapse: true,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.Analytics],
      icon: <MDSIcon.Performance variant="outline" />,
      items: [
        {
          key: AnalyticsRouteEnum.Performance,
          path: `/${RootRouteEnum.Analytics}/${AnalyticsRouteEnum.Performance}`,
          label: 'Performance',
        },
        {
          key: AnalyticsRouteEnum.CustomerReports,
          path: `/${RootRouteEnum.Analytics}/${AnalyticsRouteEnum.CustomerReports}`,
          label: 'Reports',
        },
        {
          key: AnalyticsRouteEnum.BrandExposure,
          path: `/${RootRouteEnum.Analytics}/${AnalyticsRouteEnum.BrandExposure}`,
          label: 'Brand Exposure',
        },
      ],
    },
    {
      key: RootRouteEnum.Portfolio,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.Portfolio],
      icon: <MDSIcon.Folder variant="outline" />,
      shouldCollapse: true,
      items: [
        {
          key: PortfolioRouteEnum.Assets,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.Assets}`,
          label: 'Assets',
        },
        {
          key: `${PortfolioRouteEnum.Assets}/piracy`,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.Assets}/piracy`,
          label: 'Assets',
        },
        {
          key: `${PortfolioRouteEnum.Models}`,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.Models}`,
          label: 'Models',
        },
        {
          key: `${PortfolioRouteEnum.Assets}/counterfeit`,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.Assets}/counterfeit`,
          label: 'Marketplace Assets',
        },
        {
          key: PortfolioRouteEnum.IpDocuments,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.IpDocuments}`,
          label: 'IP Documents',
        },
        {
          key: PortfolioRouteEnum.CopyrightedImages,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.CopyrightedImages}`,
          label: 'Copyrighted Images',
        },
        {
          key: PortfolioRouteEnum.InfringingImages,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.InfringingImages}`,
          label: 'Infringing Images',
        },
        {
          key: PortfolioRouteEnum.AuthorizedList,
          path: `/${RootRouteEnum.Portfolio}/${PortfolioRouteEnum.AuthorizedList}`,
          label: 'Authorized List',
        },
      ],
    },
  ],
  [
    {
      key: RootRouteEnum.Marketplace,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.Marketplace],
      icon: <MDSIcon.Shopping variant="outline" />,
      shouldCollapse: true,
      items: [
        {
          key: MarketplaceRouteEnum.Listings,
          path: `/${RootRouteEnum.Marketplace}/${MarketplaceRouteEnum.Listings}`,
          label: 'Listings',
        },
        {
          key: MarketplaceRouteEnum.ReviewNeeded,
          path: `/${RootRouteEnum.Marketplace}/${MarketplaceRouteEnum.ReviewNeeded}`,
          label: 'Review Needed',
        },
      ],
    },
    {
      key: 'all-social-media',
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SocialMedia],
      icon: <MDSIcon.SocialMedia />,
      shouldCollapse: true,
      items: [
        {
          key: SocialMediaRouteEnum.Listings,
          path: `/${RootRouteEnum.SocialMedia}/${SocialMediaRouteEnum.Listings}`,
          label: 'Counterfeit Listings',
        },
        {
          key: SocialMediaRouteEnum.Listings,
          path: `/${RootRouteEnum.SocialMedia}/${SocialMediaRouteEnum.PiracyListings}`,
          label: 'Piracy Listings',
        },
        {
          key: SocialMediaRouteEnum.ReviewNeeded,
          path: `/${RootRouteEnum.SocialMedia}/${SocialMediaRouteEnum.ReviewNeeded}`,
          label: 'Review Needed',
        },
      ],
    },
    {
      key: RootRouteEnum.SocialMedia,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SocialMedia],
      icon: <MDSIcon.SocialMedia />,
      shouldCollapse: true,
      items: [
        {
          key: SocialMediaRouteEnum.Listings,
          path: `/${RootRouteEnum.SocialMedia}/${SocialMediaRouteEnum.Listings}`,
          label: 'Listings',
        },
        {
          key: SocialMediaRouteEnum.ReviewNeeded,
          path: `/${RootRouteEnum.SocialMedia}/${SocialMediaRouteEnum.ReviewNeeded}`,
          label: 'Review Needed',
        },
      ],
    },
    {
      key: 'piracy-social-media',
      path: `/${RootRouteEnum.SocialMedia}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SocialMedia],
      icon: <MDSIcon.SocialMedia />,
      shouldCollapse: true,
    },
    {
      key: RootRouteEnum.WebsiteContent,
      path: `/${RootRouteEnum.WebsiteContent}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.WebsiteContent],
      icon: <MDSIcon.Web />,
      shouldCollapse: true,
    },
    {
      key: RootRouteEnum.DomainNames,
      path: `/${RootRouteEnum.DomainNames}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.DomainNames],
      icon: <MDSIcon.Domain />,
      shouldCollapse: true,
    },
  ],
  [
    {
      key: RootRouteEnum.SellerAnalytics,
      path: `/${RootRouteEnum.SellerAnalytics}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SellerAnalytics],
      icon: <MDSIcon.Sellers variant="outline" />,
      shouldCollapse: true,
    },
    {
      key: RootRouteEnum.SellerLink,
      path: `/${RootRouteEnum.SellerLink}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SellerLink],
      icon: <MDSIcon.Link variant="outline" />,
      shouldCollapse: true,
    },
    {
      key: RootRouteEnum.SellerIntel,
      path: `/${RootRouteEnum.SellerIntel}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.SellerIntel],
      icon: <MDSIcon.ClusterHubSellerIntel variant="outline" />,
      shouldCollapse: true,
    },
  ],
  [
    {
      key: RootRouteEnum.ConversationalAssistant,
      path: `/${RootRouteEnum.ConversationalAssistant}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.ConversationalAssistant],
      icon: <MDSIcon.Chat variant="outline" />,
    },
    {
      key: RootRouteEnum.PriceMonitoring,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.PriceMonitoring],
      icon: <MDSIcon.SearchTrend />,
      shouldCollapse: true,
      items: [
        {
          key: PriceMonitoringRouteEnum.Monitoring,
          path: `/${RootRouteEnum.PriceMonitoring}/${PriceMonitoringRouteEnum.Monitoring}`,
          label: 'Monitoring',
        },
        {
          key: PriceMonitoringRouteEnum.Analytics,
          path: `/${RootRouteEnum.PriceMonitoring}/${PriceMonitoringRouteEnum.Analytics}`,
          label: 'Analytics',
        },
      ],
    },
    {
      key: RootRouteEnum.GenerativeAI,
      path: `/${RootRouteEnum.GenerativeAI}`,
      label: ROOT_ROUTE_LABELS[RootRouteEnum.GenerativeAI],
      icon: <MDSIcon.GenerativeAI />,
    },
  ],
];
